import { render, staticRenderFns } from "./amountChange.vue?vue&type=template&id=2bb2e5c0&scoped=true"
import script from "./amountChange.vue?vue&type=script&lang=js"
export * from "./amountChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2e5c0",
  null
  
)

export default component.exports